import * as React from "react";
import {connect} from "react-redux";
import {none, Option} from "ts-option";
import {RootState} from "../../store/reducer/root/RootState";
import {Icon} from "../../hiberUiKit/src/atoms/Icon/Icon";
import InfoModule from "../../hiberUiKit/src/molecules/InfoModule/InfoModule";
import {AuthenticatedEntityTypeEnum} from "../../model/user/AuthenticatedEntity";
import User from "../../model/user/User";
import {getUser} from "../../store/view/user";
import Loading from "../ui/loading/Loading";
import DropDownWrapper from "../../hiberUiKit/src/molecules/DropDownWrapper/DropDownWrapper";
import DropDownList, {DropDownItem} from "../../hiberUiKit/src/molecules/DropDownList/DropDownList";
import MessageModal from "../lead/v4/MessageModal";
import {Dispatch} from "redux";
import Toast from "../helper/Toast";
import {sendSmsToJobCreator} from "../../store/action/job/job";
import Job from "../../model/job/Job";
import PubNubService from "../../service/PubNubService";
import {isDefined} from "../../utils/Utils";

import "./userDataDisplayer.scss";
import DateUtils from "../../utils/DateUtils";
import moment = require("moment");
import classNames = require("classnames");

interface State {
	/**
	 * Menu dropdown visibility.
	 */
	menuDropDownVisible: boolean
	/**
	 * Send sms to job creator modal visibility.
	 */
	sendSmsModalVisible: boolean;
	/**
	 * Indicates id user is active
	 */
	isActive: boolean;
	/**
	 * Last seen date time
	 */
	lastSeen: Option<moment.Moment>
	/**
	 * Indicates if tooltip is visible
	 */
	tooltipVisible: boolean
}

interface ComponentProps {
	job: Option<Job>
}

interface ReduxProps {
	/**
	 * User
	 */
	user: Option<User>;
	/**
	 * Indicates if users data is loading
	 */
	usersLoading: boolean

}

interface DispatchProps {
	/**
	 * Send sms to jobId action.
	 * @param {string} creatorId
	 * @param {string} message
	 */
	sendSmsToJobCreator: (jobId: string, message: string) => void;
}

type Props = ComponentProps & ReduxProps & DispatchProps;

/**
 * User displayer.
 */
class UserDataDisplayer extends React.PureComponent<Props, State> {
	infoModule: InfoModule;

	constructor(props: Props) {
		super(props);
		this.state = {
			menuDropDownVisible: false,
			sendSmsModalVisible: false,
			isActive: false,
			lastSeen: none,
			tooltipVisible: false
		};
		this.toggleMenu = this.toggleMenu.bind(this);
		this.onMenuOptionClick = this.onMenuOptionClick.bind(this);
		this.onSmsSend = this.onSmsSend.bind(this);
	}

	componentDidMount(): void {
		this.props.job.map(j => {
			if (j.creator.type === AuthenticatedEntityTypeEnum.User) {
				PubNubService.subscribe(j.creator.id);
				PubNubService.addPresenceListener(j.creator.id, (isActive: boolean, lastSeen?: Option<moment.Moment>) => {
					const newState: any = {isActive, ...isDefined(lastSeen) ? {lastSeen} : {}};
					this.setState(newState);
				})
			}
		});
	}

	componentWillUnmount(): void {
		this.props.job.map(j => {
			if (j.creator.type === AuthenticatedEntityTypeEnum.User) {
				PubNubService.unsubscribe(j.creator.id)
			}
		})
	}

	render() {
		const userName = this.props.user.map(u => u.getDisplayName()).getOrElse("");
		const isPhoneNumberMobile = this.props.user.flatMap(u => u.data.mobileNumber).map(p => p.isMobile());
		const phoneNumber = this.props.user.flatMap(u => u.data.mobileNumber).map(p => p.internationalPhoneNumber);
		const menuItems = [
			{
				id: "1",
				label: "Send SMS",
				disabled: phoneNumber.isEmpty || !isPhoneNumberMobile,
			}
		];
		const statusClassNames = classNames({
			"c-user-displayer_user-data_status": true,
			"active": this.state.isActive,
			"inActive": !this.state.isActive
		});
		return (
			<div className={"c-user-displayer"}>
				<InfoModule icon={Icon.User}
							title={"Job creator"}
							actionIcon={Icon.Overflow}
							onActionIconClick={this.toggleMenu}
							actionExtraIcon={Icon.Info}
							onActionExtraIconMouseOver={() => {this.setState({tooltipVisible: true})}}
							onActionExtraIconMouseOut={() => {this.setState({tooltipVisible: false})}}
							ref={(im) => this.infoModule = im}>
					{this.state.menuDropDownVisible &&
					<DropDownWrapper onOutsideClick={() => {this.setState({menuDropDownVisible: false})}}>
						<DropDownList items={menuItems}
									  itemToId={(link: DropDownItem) => link.id}
									  itemToLabel={(link: DropDownItem) => link.label}
									  itemDisabled={(link: DropDownItem) => link.disabled}
									  onSelect={() => {this.onMenuOptionClick()}}/>
					</DropDownWrapper>}
					<div className={"c-user-displayer_user-data"}>
						<Loading isLoading={this.props.usersLoading}>
							<span className="t-body" style={{whiteSpace: "pre"}}>
							{this.props.user.map(user =>
								<>
									<span><span className={statusClassNames}/>{user.getDisplayName()}</span>
									{user.data.mobileNumber.map(mn => <><br/>{mn.internationalPhoneNumber}</>).orNull}
									<br/>{user.data.username}
								</>)
								.getOrElse(
									this.props.job.map(j => j.creator).map(ae =>
										<>
											{ae.type}<br/>
											{ae.id}
										</>
									).orNull
								)}
							</span>
						</Loading>
					</div>
					{this.state.sendSmsModalVisible &&
					<MessageModal onMessageSend={(value) => this.onSmsSend(value)}
								  onClose={() => this.setState({sendSmsModalVisible: false})}
								  title={`Send SMS to: ${userName} (${phoneNumber.getOrElse("")})`}/>}
				</InfoModule>
				{this.state.tooltipVisible &&
				<div className={"c-user-displayer_tooltip"}>
					<div className={"c-user-displayer_tooltip_title"}>LAST SEEN</div>
					<div>{this.state.lastSeen.map(ls => ls.format(DateUtils.DATE_TIME_FORMAT)).getOrElse("N/A")}</div>
				</div>}
			</div>
		);
	}

	toggleMenu() {
		this.setState({menuDropDownVisible: !this.state.menuDropDownVisible})
	}

	onSmsSend(message: string) {
		this.setState({
			sendSmsModalVisible: false
		}, () => this.props.job.map(j => this.props.sendSmsToJobCreator(j.id, message)));
	}

	onMenuOptionClick() {
		this.setState({
			sendSmsModalVisible: true,
			menuDropDownVisible: false,
		})
	}
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		sendSmsToJobCreator: (jobId: string, message: string) => dispatch(
			sendSmsToJobCreator(
				jobId,
				message,
				() => Toast.success("SMS has been send.", "Send SMS to job creator"),
				() => Toast.error("Sorry, something went wrong. Try again later.", "Send SMS to job creator")
			)
		),
	}
}

function mapStateToProps(state: RootState, componentProps: ComponentProps) {
	const user = componentProps.job.map(j => j.creator).flatMap(
		jc => jc.type == AuthenticatedEntityTypeEnum.User ? getUser(jc.id) : none);
	return {user, usersLoading: state.user.user.isEmpty};
}

export default connect(mapStateToProps, mapDispatchToProps)(UserDataDisplayer)
